import React from 'react'

import {GetStaticPaths, GetStaticProps} from 'next'

import SEO from 'components/elements/SEO'
import TemplateBlogPost from 'components/templates/TemplateBlogPost'
import blogModel from 'src/backend/models/Blog.model'
import {TPageComponent} from 'src/types'
import {TPost} from 'src/types/blog'
import {getKeywords} from 'src/utils'

interface IPostProps {
	post: TPost | null
}

const Post: TPageComponent<IPostProps> = ({post}) => {
	return (
		<>
			<SEO
				title={post?.seo?.seo_title || post?.title}
				description={post?.seo?.meta_description || post?.description}
				keywords={getKeywords(post?.seo?.focus_keyword, post?.seo?.focus_synonyms)}
			/>
			<TemplateBlogPost post={post} />
		</>
	)
}

Post.displayName = 'Post'

export const getStaticProps: GetStaticProps<IPostProps> = async ({params}) => {
	try {
		const post = await blogModel.getBySlug(params?.slug as string)
		return {
			props: {post},
			revalidate: 60 * 60 * 24,
		}
	} catch {
		return {
			props: null,
			notFound: true,
		}
	}
}

export const getStaticPaths: GetStaticPaths = async () => {
	const posts = await blogModel.getAll()
	const paths = posts.map((post) => {
		return {
			params: {
				slug: post.slug?.current,
			},
		}
	})
	return {
		paths,
		fallback: 'blocking',
	}
}

export default Post
